import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import CustomLink from '../../../components/CustomLink';
import { companyData } from '../../../constants';
import CustomPhoneNumber from '../../../components/CustomPhoneNumber';


const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  white-space: pre-line;
`;

const Caption = styled.span<{ fontSize: 'smaller' | 'bigger' }>`
  color: ${({ theme }) => theme.colors.blue};
  font-weight: bold;
  font-size: ${({ fontSize }) => (fontSize === 'smaller' ? '1.2em' : '1.5em')};
  text-transform: uppercase;
  margin-bottom: 5px;
  line-height: normal;
`;

const InformationWrapper = styled.div`
  margin: 0 0 20px;
  
  :last-child{
    margin-bottom: 0;
  }
`;

const Information = styled.span`
  color: ${({ theme }) => theme.colors.lightGray};
  display: block;
`;

const CompanyInformations = () => {
  const { t } = useTranslation();

  return (
    <StyledWrapper>
      <Caption fontSize="bigger">
        {t('companysData')}
      </Caption>
      <InformationWrapper>
        <Information>
          {companyData.name}
        </Information>
        <Information>
          {companyData.addres}
        </Information>
        <Information>
          {companyData.postCode}
        </Information>
      </InformationWrapper>
      <InformationWrapper>
        <Information>
          {`${t('nip')}: ${companyData.NIP}`}
        </Information>
      </InformationWrapper>
      <Caption fontSize="smaller">
        {t('contact')}
      </Caption>
      <InformationWrapper>
        <CustomPhoneNumber
          phoneNumber={companyData.phoneNumber}
        >
          {`tel.: ${companyData.phoneNumber}`}
        </CustomPhoneNumber>
        <CustomLink
          href={`mailto:${companyData.email}`}
        >
          {`e-mail: ${companyData.email}`}
        </CustomLink>
      </InformationWrapper>
    </StyledWrapper>
  );
};

export default CompanyInformations;
